import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import PropTypes from "prop-types";
import chatgptbg from "../assets/chatgptbg.png";
import chatgptbg800 from "../assets/chatgptbg-800.png";
import chatgptbg400 from "../assets/chatgptbg-400.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    maxWidth: "900px",
    position: "relative",
    aspectRatio: "800 / 478",
  },
  bg: {
    background: "#ccc",
    width: "100%",
    height: "auto",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    position: "absolute",
    background: "#fff",
    top: "31%",
    left: "22%",
    right: "20%",
    bottom: "20%",
    overflow: "hidden",
  },
});

const XLSWindow = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.root + " gptwindow-root"}>
      <img
        className={styles.bg}
        alt="ChatGPT window background"
        src={chatgptbg}
        srcSet={`${chatgptbg400} 400w, ${chatgptbg800} 800w, ${chatgptbg} 1188w`}
        sizes="(max-width: 900px) 100vw, 900px"
      />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

XLSWindow.propTypes = {
  children: PropTypes.node.isRequired,
};

export default XLSWindow;
